import React, { Component } from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'

import { adminParcelList } from './actions/admin_parcel'

class AdminParcel extends Component {

    componentDidMount() {
        const { history, dispatch, parcel_id, parcel } = this.props
        dispatch(adminParcelList.ensureObjectLoaded(parcel_id))
        this.tryRedirect()
    }

    componentDidUpdate(prev_props) {
        const { dispatch, parcel_id } = this.props
        dispatch(adminParcelList.ensureObjectLoaded(parcel_id))
        this.tryRedirect()
    }

    tryRedirect() {
        const { history, parcel } = this.props
        if ( parcel.direction === 'donor_pickup' ) {
            history.push({pathname: '/admin/orders/donor/pickup/'+parcel.id})
        } else if ( parcel.direction === 'beneficiary_dropoff' ) {
            history.push({pathname: '/admin/orders/beneficiary/dropoff/'+parcel.id})
        } else if ( parcel ) {
            console.error("Unknown parcel type: " + parcel.direction)
        }
    }

    render() {
        return <div>Redirecting...</div>
    }

}

function mapStateToProps(state, props) {
    const parcel_id = get(props, ["match", "params", "parcel_id"], null)
    const parcel = adminParcelList.getObject(parcel_id)

    return {
        parcel_id,
        parcel,
        is_loading: adminParcelList.isLoading() || (parcel_id && !get(parcel, "id")),
        is_busy: adminParcelList.getIsSavingObject()
    }
}

export default connect(mapStateToProps)(AdminParcel)
